import { render, staticRenderFns } from "./SchoolLeaveAssignmentTableControl.vue?vue&type=template&id=8a07931c&scoped=true&"
import script from "./SchoolLeaveAssignmentTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveAssignmentTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a07931c",
  null
  
)

export default component.exports